import React, { ReactComponentElement } from 'react';
import { FullUserModel } from 'src/types/user.model';
import styles from './adminUserInfo.module.scss';

export interface AdminUserProps {
    user: FullUserModel;
}
export default function AdminUserInfo(props: AdminUserProps): ReactComponentElement<any> {
    return (
        <div className={styles.container}>
            <p>Currently logged in as...</p>
            <br />
            <LabelledText label="Name" text={props.user.forename + ' ' + props.user.surname} />
            <LabelledText label="Email" text={props.user.email} />
            <LabelledText label="User ID" text={props.user.id} />
            <LabelledText label="Plan ID" text={props.user.defaultPlan.planUid} />
        </div>
    );
}

// Helper component to reduce code duplication
function LabelledText(props: { label: String; text: String }): JSX.Element {
    return (
        <p className={styles.indented}>
            <strong>{props.label}: </strong>
            {props.text}
        </p>
    );
}
